/** Quick-add suggestions — owners can add any other country-local app by name. */
export const DELIVERY_PLATFORM_SUGGESTIONS = [
  "Uber Eats",
  "Wolt",
  "Lieferando",
  "Glovo",
  "DoorDash",
  "Deliveroo",
  "Just Eat",
  "Bolt Food",
  "Foodora",
  "Menulog",
];

export function createDeliveryPlatformLink({ name = "", url = "", id } = {}) {
  return {
    id: id || `dp_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`,
    name: String(name || "").trim(),
    url: String(url || "").trim(),
  };
}

/** Migrate legacy { uber_eats: url } map → array of { id, name, url }. */
function fromLegacyMap(links) {
  const LEGACY_LABELS = {
    uber_eats: "Uber Eats",
    wolt: "Wolt",
    lieferando: "Lieferando",
    glovo: "Glovo",
  };
  return Object.entries(links)
    .filter(([, url]) => String(url || "").trim())
    .map(([key, url]) => createDeliveryPlatformLink({
      id: key,
      name: LEGACY_LABELS[key] || key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
      url,
    }));
}

export function normalizeDeliveryPlatformLinks(links) {
  if (!links) return [];
  if (Array.isArray(links)) {
    return links
      .map((item) => createDeliveryPlatformLink(item))
      .filter((item) => item.name || item.url);
  }
  if (typeof links === "object") {
    return fromLegacyMap(links);
  }
  return [];
}

export function activeDeliveryPlatforms(links) {
  return normalizeDeliveryPlatformLinks(links).filter((item) => item.name && item.url);
}
